import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useUserPrepaidCards() {
    const { t } = useTranslation('prepaidCard');
    const { data, status } = useQuery(queries.userPrepaidCard.list());
    const prepaidCards = data?.cards;
    const toast = useToast();
    const { pop } = useFlow();
    const isLoading = status === 'pending';
    const isBlank = !isLoading && (!prepaidCards || prepaidCards.length === 0);
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('manage.error.loadFailed'));
            pop();
        }
    }, [status, toast, pop]);
    return {
        prepaidCards, isLoading, isBlank,
    };
}

export default useUserPrepaidCards;
